module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data01-fe1f2d83e9aa5e826f630f9edc028763.png";